import { useNavigate, useParams } from 'react-router-dom';
import { Visor } from './Visor';

/**
 * El visor como ruta. Salir del documento devuelve a la ficha, no a la lista:
 * quien estaba comparando versiones sigue donde estaba.
 */
export function VisorRuta() {
  const navegar = useNavigate();
  const { documentId, versionId } = useParams<{ documentId: string; versionId?: string }>();

  if (!documentId) return null;

  return (
    <Visor
      documentId={documentId}
      versionId={versionId}
      onCerrar={() => navegar(`/documentos/${documentId}`)}
    />
  );
}
